export default {
    receiptLabel: 'ใบเสร็จรับเงิน',
    transactionDate: 'วันที่ทำรายการ: ',
    invoice: 'ใบแจ้งหนี้',
    incomeAccountName: 'ชื่อบัญชีเงินเข้า',
    cardNumber: 'หมายเลขบัตร',
    promptPay: 'วิธีการชำระเงิน',
    backToHome: 'กลับสู่หน้าหลัก',
    receipt: 'ใบเสร็จ',
    failLabel: 'ชำระเงินไม่สำเร็จ',
    plsTryAgain: 'กรุณาทำรายการใหม่อีกครั้ง',
    checkCardInfo: 'โดยตรวจสอบข้อมูลบัตร หรือเลือกวิธีการชำระด้วยวิธีอื่น',
    total: 'มูลค่าสุทธิ',
    coution: 'รายการไม่อนุมัติ ไม่สามารถทำรายการได้แนะนำติดต่อธนาคารผู้ออกบัตร',
    tryAgain: 'ทำรายการอีกครั้ง'
}
